import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background: var(--bg-dark);
  color: var(--text-on-dark);
  padding: 40px 0 24px;
  margin-top: ${props => (props.$attached ? '0' : '48px')};
  border-top: ${props => (props.$attached ? '1px solid var(--border-on-dark)' : 'none')};

  :focus-visible { outline-color: var(--accent); }

  @media (max-width: 768px) {
    padding: 32px 0 20px;
  }
`;

export const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 0 16px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FooterLogo = styled(Link)`
  display: inline-flex;
  align-items: center;

  img {
    height: 24px;
    width: auto;
    max-width: 100%;
  }
`;

export const FooterLinks = styled.nav`
  display: flex;
  gap: 8px 24px;
  flex-wrap: wrap;
`;

export const FooterLink = styled(Link)`
  color: var(--text-on-dark-muted);
  font-size: var(--text-sm);
  font-weight: 500;

  &:hover { color: var(--accent); }
`;

export const FooterCopy = styled.p`
  max-width: 1152px;
  margin: 24px 24px 0;
  padding-top: 20px;
  border-top: 1px solid var(--border-on-dark);
  color: var(--text-on-dark-muted);
  font-size: var(--text-xs);

  @media (min-width: 1250px) { margin: 24px auto 0; }
  @media (max-width: 768px) { margin: 20px 16px 0; }
`;
